import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { CatalogService } from 'app/services/catalog.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { split } from 'lodash';
import { ChangeDetectorRef } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectClientesComponent } from '../../../clientes/select-clientes/select-clientes.component'
import { FuseConfirmationService } from '@fuse/services/confirmation';

@Component({
  selector: 'app-dialog-supplier',
  templateUrl: './dialog-supplier.component.html',
  styleUrls: ['./dialog-supplier.component.scss']
})
export class DialogSupplierComponent implements OnInit {
  supplierForm: UntypedFormGroup;
  currentCosts : any =[]

  supplierCost : any ={}
//////////////////////////////////////////////////
//////////////////////////////////////////////////
constructor(
  public dialog: MatDialog,
  public _dialogRef: MatDialogRef<DialogSupplierComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any,
  private _catalogService: CatalogService,
  private ref: ChangeDetectorRef,
  private _fb: FormBuilder,
  private _dialog: MatDialog,
  private _fuseConfirmationService: FuseConfirmationService,
) {

  this.supplierForm = this._fb.group({
    uuidPsServices:[this.data.uuidPsServices, [Validators.required]],
    uuidCrmCustomer         : [null,[Validators.required]],
    rutCustomer             : [null,[Validators.required]],//'66666666-6'
    nameCustores            : [null],//'CLIENTE GENERICO'

  });

 }
//////////////////////////////////////////////////
//////////////////////////////////////////////////

  ngOnInit(): void {
  }
///////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
showCustomer(){
  const dialogRef = this._dialog.open(SelectClientesComponent, {
      
    height: '80%',
    width: '100%',
    data: {
       flagCustomer     : false
      ,flagSupplier     : true
      ,flagEmployee     : false
      ,flagAssociate    : false
      ,flagDistributor  : false

    }
});
dialogRef.afterClosed().subscribe(async (result) => {
  this.supplierForm.get('uuidCrmCustomer').setValue(result.UUID_CRM_CUSTOMER      );
  this.supplierForm.get('rutCustomer').setValue(result.RUT     );
  this.supplierForm.get('nameCustores').setValue(result.CUSTOMER_FANCY_NAME     );
});
}
///////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
closeBtn(){
  // Unsuscribe to all observables
  this._dialogRef.close({refresh:false});
};
///////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
addSupplier(){
    //===============================================================
        const dialogRef = this._fuseConfirmationService.open({
          title: `Actualziar Proveedor <b>${this.supplierForm.value.nameCustores}</b>`,
          message: `¡¡Atención!!<br><b>Proveedor sera actualizado temporalmente</b> `,
          icon: {
              show: true,
              name: 'delete',
              color: 'warn'
          },
          actions: {
              confirm: {
                  label: 'Continuar',
                  color: 'warn'
              },
              cancel: {
                  show: false,
                  label: 'Cancelar',
              }
          }
        });
        dialogRef.afterClosed().subscribe(async (result) => {
              //"""""""""""""""""""""""""""""""""""""""""""""""""""""""""""
              if(result == 'confirmed'){
                var json = {
                             appToken       : null
                            ,language       : 'es'
                            ,uuidSSO        : null
                            ,uuidPsServices : this.data.uuidPsServices
                            ,uuidCustomer   : this.supplierForm.value.uuidCrmCustomer
                }
                let tmp = await  this._catalogService.setPsSupplier(json)
                this._dialogRef.close({refresh:true});
              }
              //"""""""""""""""""""""""""""""""""""""""""""""""""""""""""""  
        })     
    //===============================================================    
 
}
///////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////

}
